import { IconPicker } from "@opendash/ui";
import { Typography } from "antd";
import React from "react";
type DebugIconsProps = React.PropsWithChildren & {};

const DebugIcons = (props: DebugIconsProps) => {
  const [icon, setIcon] = React.useState<string>("");
  return (
    <div style={{ padding: 20 }}>
      <IconPicker value={icon} onChange={setIcon}></IconPicker>
      {icon && icon.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h4>Selected Icon</h4>
          <Typography.Text copyable>{icon}</Typography.Text>
          <br />
          <Typography.Text copyable>{`<Icon icon="${icon}"/>`}</Typography.Text>
        </div>
      )}
    </div>
  );
};

export { DebugIcons };
export type { DebugIconsProps };
